import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerHomeDetailsApiCall, triggerSwitchAccountApiCallSuccess } from 'redux/actions';
import { TRIGGER_SWITCH_ACCOUNT_API } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import { ChangeHistory } from 'utils';

function* triggerSwitchAccountApiCall(actions) {
	const { data } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.ACCOUNT_SWITCH,
		data,
		method: 'POST',
		options: {
			defaultLoader: false,
			restrictToast: true,
		},
	});
	if (api && api.data.statusCode === '200') {
		yield put(triggerSwitchAccountApiCallSuccess(api.data));
		yield put(triggerHomeDetailsApiCall());
		// toast.success(api.data?.message)
	} else if (api && api.data.statusCode === '400') {
		ChangeHistory(
			'push',
			`/${store.getState().homeDetails?.accountType === 'PREPAID' ? 'postpaid' : 'prepaid'}/agreement`,
		);
	}
}

export default function* triggerSwitchAccountApiCallSaga() {
	yield takeEvery(TRIGGER_SWITCH_ACCOUNT_API, triggerSwitchAccountApiCall);
}
